<template>
<el-dialog append-to-body title="选择售后订单" :visible.sync="dialogVisible" @open="handleOpen">
  <el-form :model="form" :rules="rules" ref="form">
    <el-form-item label="售后订单" prop="sales_order_id">
      <app-read-options
        style="width: 100%;"
        v-model="form.sales_order_id"
        url="sales_orders/read_options"
        label-field="display_text"
        :label-format="displaySalesOrderText"
        @select="handleSelectSalesOrder"
        :params="{ user_id_eq: $root.user.id }"
      />
    </el-form-item>
  </el-form>

  <template #footer>
    <el-button type="default" @click="dialogVisible = false">取消</el-button>
    <el-button type="primary" @click="handleSubmit">提交</el-button>
  </template>
</el-dialog>
</template>

<script>
import { Vue, Component, PropSync } from 'vue-property-decorator';

@Component
export default class DailogSalesOrders extends Vue {
  @PropSync('visible', { type: Boolean }) dialogVisible;

  form = {
    sales_order_id: null,
  }

  rules = {
    sales_order_id: [
      { required: true, message: '请选择售后订单', trigger: 'blur' },
    ],
  }

  salesOrder = null;

  handleOpen() {
    this.form.sales_order_id = null;
    this.salesOrder = null;
  }

  displaySalesOrderText(salesOrder) {
    return `销售单号: ${salesOrder.number} - 销售金额: ${salesOrder.sales_amount}`
  }

  handleSelectSalesOrder(salesOrder) {
    this.salesOrder = salesOrder;
  }

  async handleSubmit() {
    await this.$refs.form.validate();
    this.$emit('select', this.salesOrder);
    this.dialogVisible = false;
  }
}
</script>
